import { render, staticRenderFns } from "./itemTitle.vue?vue&type=template&id=22fef87f&scoped=true&"
import script from "./itemTitle.vue?vue&type=script&lang=js&"
export * from "./itemTitle.vue?vue&type=script&lang=js&"
import style0 from "./itemTitle.vue?vue&type=style&index=0&id=22fef87f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fef87f",
  null
  
)

export default component.exports